@if (form && !loading) {
  <div class="box-signle mt-3">
    <div class="row">
      <div class="col-12">
        <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
          <span class="required">*</span>
        }</p>
        @for (sm of form.choices; track trackByIndex($index)) {
          <div class="d-flex mt-2 choice-row" [class.choice-full]="isChoiceFull(sm)" (click)="toggleChoice(sm)">
            <p-checkbox name="group1" [readonly]="form.view" [disabled]="isChoiceFull(sm)" [(ngModel)]="value" [value]="sm.question_choice_id"
            (onChange)="updateValue()" (click)="$event.stopPropagation()"></p-checkbox>
            @if (sm.choice_media_url) {
              <img class="choice-media-img ml-2" [src]="resolveChoiceMediaUrl(sm.choice_media_url)" alt="" />
            }
            <span class="ml-2" [innerHTML]="sm.choice_name"></span>
            @if (isChoiceFull(sm)) {
              <span class="ml-2 choice-full-badge">เต็มแล้ว</span>
            }
          </div>
          <!-- ช่องกรอกข้อความสำหรับตัวเลือก "อื่น ๆ (ระบุ)" — โชว์เมื่อเลือกตัวเลือกนั้น -->
          @if (sm.is_other_option && value.includes(sm.question_choice_id)) {
            <div class="other-input mt-2 ml-4">
              <input type="text" class="other-text-input w-100" [disabled]="form.view"
                placeholder="โปรดระบุ..." [(ngModel)]="otherText[sm.question_choice_id]" (ngModelChange)="onOtherText()" />
            </div>
          }
        }
        <!-- <app-validate-items [action]="form.question_required" [valid]="value"
        (validUpdate)="updateValiDate($event)">
        <div class="d-flex mt-2" *ngFor="let sm of form.choices">
          <p-checkbox name="group1" [readonly]="form.view" [(ngModel)]="value" [value]="sm.question_choice_id"
          (onChange)="updateValue()"></p-checkbox>
          <span class="ml-2">{{sm.choice_name}}</span>
        </div>
      </app-validate-items> -->
    </div>
  </div>
</div>
}